/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_59be40f2"]'><cube-button inline outline>inline - outline</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_59be40f2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_59be40f2"}
  /** script content **/
  require("./btn-inline-outline.mpx.js?isComponent&outputPath=components%2Fbtn-inline-outline59be40f2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-inline-outline.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-inline-outline59be40f2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_59be40f2"],
    ctorType: "component",
    outputPath: "components/btn-inline-outline59be40f2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>